import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { supabase } from '@/lib/supabase';
import { CheckoutPage } from '@/components/checkout/CheckoutPage';

const checkoutSearchSchema = z.object({
  // A plan to preselect (an Alfie plan code or K&C tier code, case-insensitive)
  // — carried over from a /signup?plan= link when the visitor turned out to be
  // already signed in. CheckoutPage applies its own access/approval gates.
  plan: z.string().optional(),
});

export const Route = createFileRoute('/checkout')({
  beforeLoad: async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw redirect({ to: '/login', search: { redirect: '/checkout' } });
    }
  },
  validateSearch: checkoutSearchSchema,
  component: CheckoutRoute,
});

function CheckoutRoute() {
  const { plan } = Route.useSearch();
  return <CheckoutPage planParam={plan} />;
}
